import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useEmployeeAssignmentUrl } from 'domain/people/employee/assignments/assignmentRouting';
import { ListItem } from 'framework/list';

interface EditEmployeeAssignmentButtonProps extends EditButtonProps {
  isVisible?: (data: ListItem) => boolean;
}

const EditEmployeeAssignmentButton = (props: EditEmployeeAssignmentButtonProps) => {
  const { getUpdateEntityUrl } = useEmployeeAssignmentUrl();

  return <EditButton {...props} key="edit-employee-assignment" source="id" outline path={getUpdateEntityUrl} />;
};

export default EditEmployeeAssignmentButton;
